import type { SignInConfig } from '#types/config/components/form/signIn'

export default {
  brandClasses: {
    signUp: 'mt-6',
    submitButton: 'mt-6 <md:full md:flex',
    wrapper: 'space-y-2 pt-2'
  }
} satisfies SignInConfig
